/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../common/app-shared.module';
import {AdminResourcePagesModule} from '../common/controller/admin-resource-pages.module';
import {PublisherStatsModule} from '../common/controller/publisher-stats.module';
import {StatsTablesModule} from '../common/controller/stats-tables.module';
import {AdnSelectComponent} from '../common/directives/adn-select/adn-select.component';
import {ChartsModule} from '../common/directives/charts.module';
import {ExplorationComponent} from '../common/directives/exploration.component';
import {ExplorationTableComponent} from '../common/directives/exploration-table.component';
import {FormControlsModule} from '../common/directives/form-controls/form-controls.module';
import {AdminRichTextFieldComponent} from '../common/directives/notes/admin-rich-text-field.component';
import {NotesComponent} from '../common/directives/notes/notes.component';
import {ObjectNotesButtonComponent} from '../common/directives/notes/object-notes-button.component';
import {AdStatusLabelComponent} from './ad-status-component';
import {AdvertiserStatusLabelComponent} from '../advertiser/advertiser-status-component';
import {CreativePreviewModule} from '../creative/creative-preview.module';
import {ReportWidgetsModule} from '../report/report-widgets.module';
import {TargetingModule} from '../targeting/targeting.module';
import {AdTagComponent} from './ad-tag-component';
import {AdUnitAnalysisPageComponent} from './ad-unit-analysis-page.component';
import {AdUnitBulkActionModalComponent} from './ad-unit-bulk-action-modal.component';
import {AdUnitCopyModalComponent} from './ad-unit-copy-modal.component';
import {AdUnitCreativeTotalsPreviewModalComponent} from './ad-unit-creative-totals-preview-modal.component';
import {AdUnitEditPageComponent} from './ad-unit-edit-page.component';
import {AdUnitItemPageComponent} from './ad-unit-item-page.component';
import {AdUnitListPageComponent} from './ad-unit-list-page.component';
import {AdUnitSizeModalComponent} from './ad-unit-size-modal.component';

const AD_UNIT_COMPONENTS = [
  AdTagComponent,
  AdUnitAnalysisPageComponent,
  AdUnitBulkActionModalComponent,
  AdUnitCopyModalComponent,
  AdUnitCreativeTotalsPreviewModalComponent,
  AdUnitEditPageComponent,
  AdUnitItemPageComponent,
  AdUnitListPageComponent,
  AdUnitSizeModalComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    AdminResourcePagesModule,
    AdnSelectComponent,
    ChartsModule,
    CreativePreviewModule,
    ExplorationComponent,
    ExplorationTableComponent,
    FormControlsModule,
    AdminRichTextFieldComponent,
    NotesComponent,
    ObjectNotesButtonComponent,
    PublisherStatsModule,
    ReportWidgetsModule,
    AdStatusLabelComponent,
    AdvertiserStatusLabelComponent,
    StatsTablesModule,
    TargetingModule
  ],
  declarations: AD_UNIT_COMPONENTS,
  exports: AD_UNIT_COMPONENTS
})
export class AdUnitModule {
}
